import React from "react";
import { Paper as MuiPaper, makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paperBase: {
    padding: (props) => theme.spacing(props.paperSpace),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius || 16,
    backgroundColor: theme.palette.background.paper,
  },
}));

export const SKPaper = ({
  children,
  className = "",
  variant = "outlined",
  elevation = 0,
  paperSpace = 0,
  ...props
}) => {
  const classes = useStyles({ paperSpace });

  return (
    <MuiPaper className={`${classes.paperBase} ${className}`} variant={variant} elevation={elevation} {...props}>
      {children}
    </MuiPaper>
  );
};
